"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterManager = void 0;
var queryString = require('query-string');
var GenericFunctions = require("./generic-functions");
var features_filter_bar_1 = require("./features-filter-bar");
//Control the filters of the url. Add and read filters
var FilterManager = /** @class */ (function () {
    function FilterManager() {
    }
    FilterManager.setBrands = function () {
        var brandId = parseInt($(this).data("brand-id"), 10);
        var parsed = queryString.parse(location.search);
        FilterManager.resetPageNumber(parsed);
        parsed.Brands = GenericFunctions.GetArrayFromElement(parsed.Brands);
        parsed.Brands = parsed.Brands.map(function (item) { return parseInt(item, 10); });
        if (this.checked) {
            parsed.Brands.push(brandId);
            //important: order array. Cache works fine
            parsed.Brands = parsed.Brands.sort(GenericFunctions.sortNumber);
            var stringified = queryString.stringify(parsed);
            History.replaceState(null, null, "?" + stringified);
        }
        else {
            if (parsed.Brands) {
                parsed.Brands.splice(parsed.Brands.indexOf(brandId), 1);
                //remove the parameter having caché in mind
                if (parsed.Brands.length == 0) {
                    delete parsed.Brands;
                }
                var stringified = queryString.stringify(parsed);
                History.replaceState(null, null, "?" + stringified);
            }
        }
    };
    FilterManager.getCurrentBrandsFilter = function () {
        var parsed = queryString.parse(location.search);
        var brands = GenericFunctions.GetArrayFromElement(parsed.Brands);
        $("#brands-filter-bar li input").prop('checked', false);
        brands.forEach(function (element) {
            $("#brands-filter-bar li input[data-brand-id=" + element + "]").prop('checked', true);
        });
        $("#brands-filter-bar-mobile li input").prop('checked', false);
        brands.forEach(function (element) {
            $("#brands-filter-bar-mobile li input[data-brand-id=" + element + "]").prop('checked', true);
        });
    };
    FilterManager.getCurrentFeaturesFilter = function () {
        var parsed = queryString.parse(location.search);
        var features = GenericFunctions.GetArrayFromElement(parsed.Features);
        features.forEach(function (element) {
            var $element = $("#feature-value-" + element);
            var $mobileElement = $("#mobile-feature-value-" + element);
            $element.addClass("selected");
            $mobileElement.addClass("selected");
            var featureId = $element.parent().data("parent-feature-id");
            $("#feature-" + featureId).addClass("selectedWithItem");
            $("#feature-" + featureId).children(".feature-selected-point").first().css("display", "block");
        });
        //expand the last selected filter item
        var filterItemPreselected = $("#feature-" + features_filter_bar_1.FeaturesFilterBar.LastExpandedFeatureFilter);
        if (filterItemPreselected.length != 0) {
            features_filter_bar_1.FeaturesFilterBar.clickFeatureEvent.call(filterItemPreselected);
        }
        else if ($(features_filter_bar_1.FeaturesFilterBar.idSelector + " .selectedWithItem").length > 0) {
            var filter = $(features_filter_bar_1.FeaturesFilterBar.idSelector + " .selectedWithItem").first();
            features_filter_bar_1.FeaturesFilterBar.clickFeatureEvent.call(filter);
        }
        else {
            var firstFilterItem = $(features_filter_bar_1.FeaturesFilterBar.idSelector).find(".feature-filter-item").first();
            if (firstFilterItem.length != 0) {
                features_filter_bar_1.FeaturesFilterBar.clickFeatureEvent.call(firstFilterItem);
            }
        }
    };
    FilterManager.setFeatures = function () {
        var parsed = queryString.parse(location.search);
        FilterManager.resetPageNumber(parsed);
        parsed.Features = GenericFunctions.GetArrayFromElement(parsed.Features);
        parsed.Features = parsed.Features.map(function (item) { return parseInt(item, 10); });
        $(this).each(function () {
            var features = parseInt($(this).data("feature-value-id"), 10);
            if ($(this).hasClass("selected")) {
                parsed.Features.push(features);
                //important: order array. Cache works fine
                parsed.Features = parsed.Features.sort(GenericFunctions.sortNumber);
            }
            else {
                if (parsed.Features) {
                    parsed.Features.splice(parsed.Features.indexOf(features), 1);
                    //remove the parameter having caché in mind
                    if (parsed.Features.length == 0) {
                        delete parsed.Features;
                    }
                }
            }
        });
        var stringified = queryString.stringify(parsed);
        History.replaceState(null, null, "?" + stringified);
    };
    FilterManager.resetPageNumber = function (query) {
        delete query.page;
    };
    return FilterManager;
}());
exports.FilterManager = FilterManager;
